import {observer} from 'mobx-react';
import React from 'react';
import {Navigate} from 'react-router';
import {generatePath} from 'react-router-dom';


import getPathForRawPath from '../../routes/Paths/getPathForRawPath';
import usePathParams from '../../routes/Paths/usePathParams';
import workspaceIdToParam from '../../stores/Workspaces/utils/workspaceIdToParam';
import useStore from '../../stores/useStore';


const SettingsRedirect = observer(() => {
  const {activeWorkspace} = useStore();
  const params = usePathParams();

  const [workspaceId, setWorkspaceId] = React.useState<string | undefined>(
    workspaceIdToParam(activeWorkspace.id)
  );

  React.useEffect(() => {
    if (activeWorkspace.id) {
      setWorkspaceId(workspaceIdToParam(activeWorkspace.id));
    }
  }, [
    activeWorkspace.id,
  ]);

  const path = getPathForRawPath(window.location.pathname);

  const redirectPath = path ? generatePath(path, {
    ...params,
    workspaceId: workspaceId || '',
    page: null,
    subpage: null,
  }) : path;
  console.debug('redirectPath=', redirectPath);

  return redirectPath && workspaceId ? (
    <Navigate
      to={`${redirectPath}${location.search}`}
      replace
    />
  ) : null;
});

export default SettingsRedirect;
